import React, { useEffect, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { useFiltrationModel } from "../../filtrationModel";

export const Content = () => {
	const { filtrationOne } = useFiltrationModel();
	const [shiftCurrent, setShiftCurrent] = useState<boolean>(true);
	useEffect(() => {
		// console.log(filtrationOne)
		if (filtrationOne[0]?.sourceFrom === "北京产权交易平台" || filtrationOne[0]?.sourceFrom === "天津产权交易平台" || filtrationOne[0]?.sourceFrom === "北交互联" || filtrationOne[0]?.sourceFrom === "公共资源" || filtrationOne[0]?.sourceFrom === "云筑网") {
			setShiftCurrent(false)
			window.open(filtrationOne[0]?.detailLink, `${filtrationOne[0]?.title}`, "width=400,height=400,screenX=200,screenY=200")
		}
	}, [])

	const renderContent = () => {
		if (filtrationOne[0]?.rawContent) {
			return filtrationOne[0]?.rawContent ?? "<span>暂无内容,请通过原文链接进行访问。</span>";
		} else {
			return `<span>${filtrationOne[0]?.textContent ?? '暂无内容,请通过原文链接进行访问。'}</span>`;
		}
	}


	return (
		<YhBox
			title=" "
			style={{ padding: 0, marginBottom: "15px" }}
		>
			<div className="iframe-container" style={{ width: `100%` }}>
				<span
					style={{ display: "inline-block", width: "80px", height: "20px", border: "1px solid #aaa", fontSize: "12px", lineHeight: "20px", textAlign: "center", cursor: "pointer" }}
					onClick={() => setShiftCurrent(origin => !origin)}
				>{shiftCurrent ? "转换原文内容" : "转换Iframe"}</span>
				{
					shiftCurrent && filtrationOne[0]?.detailLink && filtrationOne[0].detailLink.indexOf("http") > -1 ? <>
						<iframe
							id="ifr"
							src={filtrationOne[0]?.sourceFrom === "中国交建" ? `./iframePost.html?actionBms=${filtrationOne[0]?.detailLink}&oid=${filtrationOne[0]?.oid}` :
								// filtrationOne[0]?.sourceFrom === "中国石油招标投标网" ? `./iframePetrochina.html?actionBms=https://www.cnpcbidding.com&oid=${filtrationOne[0]?.oid}` :
								filtrationOne[0]?.sourceFrom === "中国石油招标投标网" ? "https://www.cnpcbidding.com" :
									filtrationOne[0]?.sourceFrom === "中国电建" ? `./iframePost.html?actionBms=${filtrationOne[0]?.pdfviewLink ?? filtrationOne[0]?.detailLink}&oid=${filtrationOne[0]?.oid}` :
										filtrationOne[0]?.sourceFrom === "中铁鲁班商务网" ? `./iframe.html?actionBms=${filtrationOne[0]?.pdfviewLink ?? filtrationOne[0]?.detailLink}` :
											filtrationOne[0]?.sourceFrom === "中国石化物资招标投标网" ? `./iframeSinopec.html?actionBms=${filtrationOne[0]?.detailLink}` :
												filtrationOne[0]?.sourceFrom === "中国招标投标公共服务平台" ? `./iframeSinopec.html?actionBms=${filtrationOne[0]?.pdfviewLink ?? filtrationOne[0]?.detailLink}` :
													`./iframe.html?actionBms=${filtrationOne[0]?.detailLink}`
							}
							// src={`${filtrationOne[0]?.detailLink}`}
							scrolling="yes"
							frameBorder="0"
							style={{ width: '100%', height: "100%", overflow: 'visible' }}
						></iframe></>
						// : <div className="ml-20" style={{ height: "100%", overflow: "auto" }} >{filtrationOne[0]?.rawContent ?? "暂无内容"}</div>
						: <div className="ml-20" style={{ height: "100%", padding: "0 0 20px", overflow: "auto" }} dangerouslySetInnerHTML={{ __html: renderContent() }}></div>
				}
			</div>
		</YhBox>
	)
}